import { flatten } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export default class ActivityFormService {
    constructor(_objectType) {
        switch (_objectType) {
            case 'task':
                this.getActivity = (id) => this.getTask(id);
                this.createActivity = ({ activity, date }) => this.createTask({ activity, date });
                this.updateActivity = ({ activity, date }) => this.updateTask({ activity, date });
                break;
            case 'event':
                this.getActivity = (id) => this.getEvent(id);
                this.createActivity = ({ activity, date }) => this.createEvent({ activity, date });
                this.updateActivity = ({ activity, date }) => this.updateEvent({ activity, date });
                break;
            case 'phonecall':
                this.getActivity = (id) => this.getPhoneCall(id);
                this.createActivity = (activity) => this.createPhoneCall(activity);
                this.updateActivity = (activity) => this.updatePhoneCall(activity);
                break;
        }
    }

    createTask({ activity, date }) {
        const due_date = date.due_date;
        return ApiClient.post(
            '/tasks',
            {},
            { ...activity, assigned_staff_ids: activity.staffs, due_date },
        );
    }

    async getTask(taskId) {
        const { data: data } = await ApiClient.get(`/tasks/${taskId}`, {
            embed: ['assigned_staffs', 'acl', 'related'],
        });
        data.staffs = data.assigned_staff_ids;
        return data;
    }

    updateTask({ activity, date }) {
        const due_date = date.due_date;
        return ApiClient.put(
            `/tasks/${activity.id}`,
            {},
            { ...activity, assigned_staff_ids: activity.staffs, due_date },
        );
    }

    createEvent({ activity, date }) {
        const staffs = activity.staffs.map((staffId) => {
            return { id: staffId, type: 'staff' };
        });

        return ApiClient.post(
            '/calendar-events',
            {},
            {
                ...activity,
                datetime_start: date.datetime_start,
                datetime_end: date.datetime_end,
                all_day: date.all_day,
                participants: [...staffs, ...activity.contacts],
                wants_meet_link: activity.wantsMeetLink ?? false,
            },
        );
    }

    async getEvent(eventId) {
        const { data: data } = await ApiClient.get(`/calendar-events/${eventId}`, {
            embed: ['participants', 'acl', 'related'],
        });
        data.staffs = data.participants
            .filter(({ type }) => type === 'staff')
            .map((participant) => participant.id);
        data.contacts = data.participants
            .filter(({ type }) => type !== 'staff')
            .map((participant) => participant.id);
        return data;
    }

    updateEvent({ activity, date }) {
        const staffs = activity.staffs.map((staffId) => {
            return { id: staffId, type: 'staff' };
        });

        return ApiClient.put(
            `/calendar-events/${activity.id}`,
            {},
            {
                ...activity,
                datetime_start: date.datetime_start,
                datetime_end: date.datetime_end,
                all_day: date.all_day,
                participants: [...staffs, ...activity.contacts],
                wants_meet_link: activity.wantsMeetLink ?? false,
            },
        );
    }

    createPhoneCall(activity) {
        return ApiClient.post('/phone-calls', {}, activity);
    }

    async getPhoneCall(phoneCallId) {
        const { data: data } = await ApiClient.get(`/phone-calls/${phoneCallId}`, {
            embed: ['acl', 'related'],
        });
        return data;
    }

    updatePhoneCall(phoneCallData) {
        return new Promise((resolve, reject) => {
            const uuid = uuidv4();
            const request = [
                { uri: `/phone-calls/${phoneCallData.id}`, method: 'GET', uuid },
                {},
                { uri: `/phone-calls/${phoneCallData.id}`, method: 'PUT', uuid },
                {
                    ...phoneCallData,
                },
            ];
            ApiBatchClient.post('/batch', {}, flatten(request).map(JSON.stringify).join('\n'))
                .then(({ data }) => {
                    if (data.responses.some((response) => response.code === 404)) {
                        reject();
                    }
                    resolve({ data: data.responses[1]?.response });
                })
                .catch((error) => reject(error));
        });
    }
}
